/**
 * @fileoverview GET handler for the "/:app_group_id/generative_ai/agents/campaign_qa" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgentsCampaignQa } from "./constants";
import type { GetGenerativeAiAgentsCampaignQaParams, GetGenerativeAiAgentsCampaignQaResult } from "./types";
import { isGetGenerativeAiAgentsCampaignQaResult } from "./validators";

export const getGenerativeAiAgentsCampaignQa = reactQueryFetcherAdapter(
  generativeAiAgentsCampaignQa,
  (
    signal: AbortSignal,
    { appGroupId, campaignTerritoryIds }: GetGenerativeAiAgentsCampaignQaParams
  ): Promise<GetGenerativeAiAgentsCampaignQaResult> => {
    const queryParams = new URLSearchParams();
    (campaignTerritoryIds ?? []).forEach((id) => queryParams.append("campaign_territory_ids[]", id));
    const queryString = queryParams.toString();
    const url = queryString
      ? `/${appGroupId}/generative_ai/agents/campaign_qa?${queryString}`
      : `/${appGroupId}/generative_ai/agents/campaign_qa`;
    return fetch(url, "GET", {}, { signal }, { propagateFetchRequestError: false });
  },
  isGetGenerativeAiAgentsCampaignQaResult
);
